/* eslint-disable @typescript-eslint/no-empty-function */
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IconSvgComponent } from '../icon/icon.component';
import { headShake } from '../../animations/animations';
import { PillChangeEvent } from '../../models/pill-change-event.model';
@Component({
  standalone: true,
  selector: 'rx-applications-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss'],
  imports: [CommonModule, IconSvgComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PillComponent), //tslint:disable-line
      multi: true,
    },
  ],
  animations: [headShake],
})
export class PillComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input() label: string;
  @Input() selected = false;
  @Input() range = false;
  @Input() testIdPrefix = 'pill';
  @Input() showSelectedIcon: boolean;
  @Input() icon = 'checkmark';
  @Input() alwaysShowIcon = false;
  @Input() allowUnselect: boolean = true;

  @Output() toggle = new EventEmitter<PillChangeEvent>();

  onChange = (_: unknown) => {};
  onTouch = (_: unknown) => {};

  writeValue(selected: boolean): void {
    this.selected = selected;
  }

  registerOnChange(angularFunction): void {
    this.onChange = angularFunction;
  }

  registerOnTouched(angularFunction): void {
    this.onTouch = angularFunction;
  }

  clickPill($event: Event): void {
    $event.preventDefault();
    if (!this.selected || this.allowUnselect) {
      this.selected = !this.selected;
      this.onChange(this.selected);
      this.toggle.emit({ id: this.id, selected: this.selected });
    }
  }

  get testId(): string {
    return `${this.testIdPrefix}-${this.id}`;
  }
}
